<template>
  <el-select v-model="selectedCity" placeholder="Select city" @change="$emit('change', selectedCity)">
    <el-option v-for="city in cities" :key="city" :label="city" :value="city">
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    cities: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCity: null,
    };
  },
};
</script>

<style>
</style>
